var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      ref: "link",
      class: {
        eventNode: true,
        selected: _vm.selected,
        read: _vm.event.Read,
        unread: !_vm.event.Read
      },
      style: _vm.nodeStyle,
      attrs: { href: _vm.nodeLink, draggable: !_vm.event ? "false" : "true" },
      on: {
        click: _vm.nodeClick,
        contextmenu: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.onContextmenu($event)
        },
        dragstart: _vm.dragStart,
        keydown: [
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.upPressed($event)
          },
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown"
              ])
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.downPressed($event)
          }
        ]
      }
    },
    [
      _c("div", { staticClass: "firstLine" }, [
        _c("span", { staticClass: "types" }, [
          _c("span", { staticClass: "eventType" }, [
            _vm._v(_vm._s(_vm.event.EventType))
          ]),
          _vm._v(":\n\t\t\t"),
          _c("span", { staticClass: "subType" }, [
            _vm._v(_vm._s(_vm.event.SubType))
          ])
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "date" }, [
          _vm._v(_vm._s(_vm.eventDateFormat(new Date(_vm.event.Date))))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "secondLine" }, [
        _c("span", { staticClass: "message" }, [
          _vm._v(_vm._s(_vm.event.Message))
        ]),
        _vm._v(" "),
        _vm.event.CTag
          ? _c("span", { staticClass: "ctag" }, [
              _vm._v(_vm._s(_vm.event.CTag))
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }